import React from 'react';
import './App.css';
import { BrowserRouter as Router } from 'react-router-dom';
import WorkspaceRoutes from './Utilities/WorkspaceRoutes';
import Loader from './Components/ComponentFragments/Loader';
import CacheBuster from './CacheBuster';

class App extends React.Component {
    render() {
        //return (
        //    <Router>
        //        <WorkspaceRoutes />
        // //   </Router>
        //);
        return (
            <CacheBuster>
                {({ loading, isLatestVersion, refreshCacheAndReload }) => {
                    if (loading) return null;
                    if (!loading && !isLatestVersion) {
                        refreshCacheAndReload();
                    }

                    return (
                        <Router>
                            <WorkspaceRoutes />
                        </Router>
                    );
                }}
            </CacheBuster>
        );
    }
    
}
export default App;